import PropTypes from "prop-types"
import { connect } from "react-redux"
import styled from "styled-components"

const Key = styled.button`
  background-color: #646464;
  border: 1px solid #191919;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  font-size: ${(props) => (props.backspace ? "32px" : "28px")};
  height: 51px;
  margin-right: 5px;
  padding: 1px 6px;
  width: ${(props) => (props.backspace ? "64px" : "44px")};
  &:last-child {
    margin-right: 0;
  }
  &:active {
    background-color: #4268ff;
    outline: none;
  }
  ${(props) =>
    props.keyboard === "arabic" &&
    `
    font-size: ${props.backspace ? "20px" : "16px"};
    margin-right: 1px;
    width: ${props.backspace ? "42px" : "28px"};

    ${props.theme.mediaQueries.tablet`
      font-size: ${props.backspace ? "32px" : "28px"};
      margin-right: 3px;
      width: ${props.backspace ? "62px" : "42px"};

    `}
  `}
`

const KeyboardRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
`

const KeyboardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;
`

const keyboards = {
  arabic: [
    ["backspace", "اَ", "أ", "آ", "إ", "اِ", "أو", "او", "اُ", "ژ"],
    ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح", "ج", "چ"],
    ["ش", "س", "ی", "ب", "ل", "ا", "ت", "ن", "م", "ك", "ک", "گ"],
    ["ظ", "ط", "ز", "ر", "ذ", "د", "پ", "و", "ي"],
  ],
  hebrew: [
    ["backspace", "ק", "ר", "א", "ט", "ו", "ן", "ם", "פ"],
    ["ש", "ד", "ג", "כ", "ע", "י", "ח", "ל", "ך", "ף"],
    ["ז", "ס", "ב", "ה", "נ", "מ", "צ", "ת", "ץ"],
  ],
}

const InternalKeyboard = ({ type, engraving, currentText, setEngraving }) => {
  if (!engraving) {
    return null
  }

  return (
    <KeyboardWrapper>
      {keyboards[type].map((row, i) => (
        <KeyboardRow key={"row" + i} type={type}>
          {row.map((k, ki) => (
            <Key
              backspace={k === "backspace"}
              key={"key" + ki}
              keyboard={type}
              onClick={() => setEngraving(engraving, currentText, k)}
              type="button"
            >
              {k === "backspace" ? "➞" : k}
            </Key>
          ))}
        </KeyboardRow>
      ))}
    </KeyboardWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    currentText:
      state.choices.e1 && !state.choices.e1.is_default
        ? state.choices.e1.value
        : "",
    engraving: state.wizard.data.e1,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setEngraving: (engraving, currentText, pressedKey) => {
      let newText = ""
      if (pressedKey === "backspace") {
        newText = currentText.substr(0, currentText.length - 1)
      } else if (ownProps.type == "arabic") {
        newText = pressedKey
      } else {
        newText = currentText + pressedKey
      }
      engraving.value = newText

      ownProps.enterInput(engraving, false, ownProps.setFastEngravingValue)
    },
  }
}

InternalKeyboard.propTypes = {
  currentText: PropTypes.string,
  engraving: PropTypes.object,
  setEngraving: PropTypes.func,
  type: PropTypes.string,
}

const Keyboard = connect(mapStateToProps, mapDispatchToProps)(InternalKeyboard)

export default Keyboard
